import { useApp } from '../context/AppContext'

export default function Toast() {
  const { toast } = useApp()
  return (
    <div
      className="absolute left-1/2 pointer-events-none z-50 transition-all duration-300 whitespace-nowrap max-w-xs text-center"
      style={{
        bottom: '76px',
        transform: `translateX(-50%) translateY(${toast.show ? 0 : '20px'})`,
        background: 'rgba(0,0,0,0.75)',
        color: 'white',
        padding: '8px 18px',
        borderRadius: '20px',
        fontSize: '13px',
        opacity: toast.show ? 1 : 0,
      }}
    >
      {toast.msg}
    </div>
  )
}
